import type { AutomationTrigger } from '../../api/types';

/**
 * What "start from one that sends itself" fills in — the first-visit tiles on
 * the Campaigns home open the automation editor with one of these, so a
 * newcomer starts from a message somebody would actually send rather than an
 * empty form. Only a starting point: nothing is saved until they save it, and
 * nothing sends until somebody allowed to switches it on.
 */
export interface AutomationPreset {
  trigger: AutomationTrigger;
  name: string;
  delayHours: number;
  subject: string;
  bodyHtml: string;
}

export const AUTOMATION_PRESETS: Record<AutomationTrigger, AutomationPreset> = {
  trip_completed: {
    trigger: 'trip_completed',
    name: 'Thank you after a trip',
    delayHours: 24,
    subject: 'Thanks for riding with us, {{name}}',
    bodyHtml:
      '<p>Hi {{name}},</p><p>Thank you for travelling with {{company_name}}. If anything about your trip ' +
      'could have been better, just reply — it comes straight to our team.</p>',
  },
  first_booking: {
    trigger: 'first_booking',
    name: 'Welcome first-time bookers',
    delayHours: 0,
    subject: 'Welcome to {{company_name}}, {{name}}',
    bodyHtml:
      '<p>Hi {{name}},</p><p>Thank you for booking with us for the first time. If you need anything ' +
      'before your trip, reply to this email and our team will help.</p>',
  },
  lapsed: {
    trigger: 'lapsed',
    name: 'Win back quiet customers',
    delayHours: 0,
    subject: 'It has been a while, {{name}}',
    bodyHtml:
      '<p>Hi {{name}},</p><p>We have not driven you in a while. Whenever you next need a car, we would ' +
      'be glad to — reply to this email, or book online any time.</p>',
  },
};
